import * as React from 'react';

import { useBalloonAutoClose } from './useBalloonAutoClose';
import { useBalloonInstance } from './useBalloonInstance';
import { EClusterPinAnchor } from '../../../../../constants/clusterPins/types';
import { TFeatureWithPrecision } from '../../../../../types/map';
import { ISafeAreaInsets } from '../utils/getBalloonPosition';

interface IUseOfferPreviewBalloonParams {
  activeFeature: TFeatureWithPrecision;
  anchor: EClusterPinAnchor;
  map: YMaps.Map;
  onClose(): void;
  previewHeight: number;
  previewWidth: number;
  safeArea: ISafeAreaInsets;
  ymaps: YMaps.IYMaps;
}

export function useOfferPreviewBalloon({
  activeFeature,
  anchor,
  map,
  onClose,
  previewHeight,
  previewWidth,
  safeArea,
  ymaps,
}: IUseOfferPreviewBalloonParams): HTMLDivElement | null {
  const reactId = React.useId();
  // React.useId() возвращает строку с двоеточиями (:r0:), они недопустимы как HTML id в некоторых браузерах
  const slotId = `offer-preview-balloon-slot-${reactId.replace(/:/g, '')}`;

  const { portalContainer, rootElement } = useBalloonInstance({
    activeFeature,
    anchor,
    map,
    previewHeight,
    previewWidth,
    safeArea,
    slotId,
    ymaps,
  });

  useBalloonAutoClose({ rootElement, map, onClose });

  return portalContainer;
}
